import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        postId: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.close()"></button>
            <h2 ng-if="!vm.postId">{{ 'training.Add materials' | translate }}</h2>
            <h2 ng-if="vm.postId">{{ 'training.Edit study material' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="iframe-wrapper02">
                <div class="inner">
                    <iframe
                        ng-src="{{ vm.url }}"
                        height="{{ vm.height }}"
                        frameborder="0"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $window, ModalService, MaterialService, TokenService) {
        this.$translate = $translate;
        this.$window = $window;
        this.ModalService = ModalService;
        this.MaterialService = MaterialService;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.height = this.$window.innerHeight * 90 / 100;
        if (this.postId) {
            this.url = this.MaterialService.getTokenizedUrl(
                this.MaterialService.getCourseEditUrl(
                    this.postId,
                    this.TokenService.getCompanyLanguage(true)
                ),
                this.TokenService.token
            );
        }
        else {
            this.url = this.MaterialService.getTokenizedUrl(
                this.MaterialService.getCourseAddUrl(),
                this.TokenService.token
            );
        }
    }

    close () {
        this.ModalService.confirm(this.$translate.instant('training.Close materials add modal confirm.')).then(() => {
            this.uibModalInstance.dismiss();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/version/training/ldMaterial/index.js